import React from 'react'
import { globalState } from '../../store'
import { UserListPage } from '../../components/users'
import { useFetch } from '../../components/component-items/helpers'

export const WarehouseUsersPage = () => {
  const {
    state: { csrf, warehouseActive, usersPermittedWarehouses },
  } = globalState()

  // Fetch available roles for filtering
  const { response: rolesResp, loaded: rolesLoaded } = useFetch('/api/rbac/roles/?user_type=warehouse', {})
  const roles =
    rolesLoaded && rolesResp?.results
      ? [...rolesResp.results]
          .sort((a: any, b: any) => b.level - a.level)
          .map((r: any) => ({ id: r.id, name: r.name, level: r.level }))
      : []

  // Convert warehouses to filter format (use user's permitted warehouses from RBAC)
  const warehouses = usersPermittedWarehouses?.map((w: any) => ({ id: w.id, name: w.name })) || []

  return (
    <UserListPage
      userType="warehouse"
      title="Warehouse Users"
      warehouseId={warehouseActive?.id}
      csrf={csrf}
      permissionsBasePath="/warehouse/users"
      warehouses={warehouses}
      roles={roles}
    />
  )
}
